import axios from 'axios';
import { Session } from "../framework/Session";
import { Local_Storage,session_Storage } from "@/store/local.storage";
import $globals from '@/h5_src/framework/Globals';

let HttpControl = {
    // 是否用 2.0 的 32 位 token 代替 JWT 版本的 token
    uriMap: {},
    // 为了同时兼容新老版本，server-api 会设置 using = true，而每次请求完毕会重置 using = false
    setUsing(uri, using) {
        this.uriMap[uri] = !!using;
    },
    getUsing(uri) {
        return this.uriMap[uri] || false;
    }
};

export const AxHttpControl = HttpControl;

axios.interceptors.request.use(
    config => {

        let savedSession = session_Storage.getSession();
        console.log(session_Storage.getSession(),Local_Storage.getSession())
        // console.log(['request-config', config.url]);
        let token = savedSession.token || '';
        let using = HttpControl.getUsing(config.url);
        if (token && using) {
            config.headers.Authorization = token
        }
        config.headers.Accept = 'application/json'
        return config
    },
    error => {
        return Promise.reject(error)
    }
)



axios.interceptors.response.use((response) => {
    console.log(response);
    if(response.status === 401){
         Session.clearLoginStatus();
        return Promise.reject(response.data.error);
    }
    //处理权限相关的
    if (response.status == 200 && response.data.succ != 1 && response.data.code == 401) {
        Session.clearLoginStatus();
        return Promise.reject(response.data.error);
    }

    if(response.data.code==403){
        console.log(response)
        Session.clearLoginStatus();
        $globals.$vm.$notifyError(response.data.message);
    }
    // if(response.data.code===500){
    //     $globals.$vm.$notifyError(response.data.message);
    // }

    //权限错误
    if (response.data.code == -1) {
        return response;

    } else if (response.data.succ != 1 && response.data.status != 1 && response.status != 200) {
        if ([501, 502].indexOf(response.data.code) > -1) {
            // console.log(['http-501-502']);
            Session.setExpired(response.data.code);
        }
        // showErrorMsg(response.data.error_info);
        return Promise.reject(response.data.error);
    }
    // return response.data;
    return response;
}, (error) => {
    const { response } = error
    // 未授权
    if (response && (response.status == 401 || response.data.code == 401 || response.data.code === 403)) {
        $globals.$vm.$notifyError(response.data.error);
        Session.clearLoginStatus();
    }
    // Toast.offline('网络传输错误', 1);
    return Promise.reject(error);
});

export class Http {

    protected baseUrl: string = '';

    constructor() {
        this.baseUrl = '';
    }

    public setBaseUrl(base: string) {
        this.baseUrl = base;
    }

    public getBaseUrl() {
        return this.baseUrl;
    }

    public static getHandler() {
        return axios;
    }

}

